import type { apiErrors as apiErrorsEn } from "../en/apiErrors";

// Kódy chyb API → český text (vize F13.9). Texty říkají redaktorovi, CO UDĚLAT, a jmenují
// ovládací prvky jejich českým popiskem z adminu. Čísla číslovku neskloňují („počet: 2") —
// klíč je přesně kód, plurálové přípony tu nejsou. `{{slugs}}` dosazuje admin z
// `RESERVED_DESTINATION_SLUGS`, `{{when}}` čas změny, `{{file}}` jméno souboru.
export const apiErrors: typeof apiErrorsEn = {
  destination_parent_self: "Destinace nemůže být sama sobě nadřazenou destinací.",
  destination_parent_not_found:
    "Vybraná nadřazená destinace už neexistuje. Obnovte stránku a vyberte jinou.",
  destination_parent_not_country_level:
    "Nadřazenou destinací může být jen země, nebo lokalita se zapnutým „Zobrazovat jako zemi“.",
  destination_with_places_needs_show_as_country:
    "Destinace má vlastní lokality, takže pod jinou destinaci ji jde zařadit, jen když má zapnuté „Zobrazovat jako zemi“. Zapněte ho, nebo nejdřív přesuňte její lokality.",
  destination_with_places_needs_top_level_parent:
    "Destinace s vlastními lokalitami musí ležet přímo pod zemí — hierarchie má nejvýš tři úrovně.",
  destination_in_use:
    "Destinaci „{{name}}“ nejde smazat, protože na ní závisí lokality (počet: {{places}}) a zájezdy (počet: {{trips}}). Nejdřív lokality přesuňte a zájezdy odpojte.",

  slug_format: "Slug smí obsahovat jen malá písmena bez diakritiky, číslice a pomlčky.",
  slug_reserved:
    "Tento slug je vyhrazený pro typ zájezdu nebo podstránku destinace ({{slugs}}). Zvolte jiný.",
  value_taken: "Tahle hodnota už je použitá. Zvolte prosím jinou.",

  url_https_required: "Zadejte celou webovou adresu začínající https://.",

  hotel_coordinates_pair: "Souřadnice hotelu musí mít zeměpisnou šířku i délku zároveň.",
  hotel_room_ids_unique: "Typy pokojů musí mít jedinečné ID.",
  hotel_meal_plans_unique: "Každý druh stravování jde nabídnout jen jednou.",
  hotel_departures_unique: "Místa odletu se nesmí opakovat.",
  trip_experience_field_required: "U zážitku je povinné.",
  trip_tour_field_required: "U okruhu je povinné.",
  trip_reorder_invalid:
    "Nové pořadí zájezdů nejde uložit — seznam je neplatný. Obnovte stránku a zkuste to znovu.",
  departure_capacity_required:
    "Kapacita je povinná — zájezd nemá horní hranici skupiny, ze které by se dopočítala.",
  departure_capacity_invalid: "Kapacita musí být číslo (0 nebo víc).",

  team_member_name_required: "Jméno člena týmu je povinné.",

  conflict: "Záznam mezitím změnil někdo jiný ({{when}}), když jste ho měli otevřený.",

  media_alt_required: "Alt text je povinný (kvůli SEO a přístupnosti).",
  media_no_file: "Nebyl vybrán žádný soubor.",
  media_alts_mismatch: "Počet alt textů neodpovídá počtu souborů.",
  media_fields_missing: "Vyberte média i cílovou složku.",
  media_folder_invalid: "Vybraná složka neexistuje.",
  media_no_ids: "Nejsou vybraná žádná média.",
  media_too_large: "{{file}}: soubor je příliš velký. Největší povolená velikost je {{maxMb}} MB.",
  media_type_not_allowed: "{{file}}: tento typ souboru není povolený. Povolené typy: {{types}}.",
  media_svg_unsafe: "{{file}}: SVG obsahuje potenciálně nebezpečný obsah.",
  media_content_invalid:
    "{{file}}: obsah souboru neodpovídá žádnému podporovanému formátu obrázku.",
  media_mime_mismatch: "{{file}}: obsah souboru neodpovídá jeho deklarovanému typu.",
  media_exceeds_image_limits:
    "{{file}}: fotka je větší, než zpracování dovolí (nejvýš {{maxMb}} MB, {{maxPx}} px na stranu a {{maxMp}} Mpx).",
  media_upload_failed: "Nahrání se nepodařilo: {{reason}}",
  media_ai_failed: "Návrh popisku pomocí AI se nepodařil: {{reason}}",
  media_restore_live_twin: "V knihovně už je živá fotka se stejným obsahem.",
  media_country_not_country_level:
    "Zemí fotky může být jen země, nebo lokalita se zapnutým „Zobrazovat jako zemi“.",
  guide_country_not_country_level:
    "Zemí průvodce může být jen země, nebo lokalita se zapnutým „Zobrazovat jako zemi“.",

  album_name_required: "Název alba je povinný.",
  album_parent_self: "Album nejde vnořit samo do sebe.",
  album_parent_descendant: "Album nejde přesunout pod své vlastní podalbum.",
  album_nothing_to_update: "Není co uložit.",
  album_no_media: "Nejsou vybraná žádná média.",

  review_name_required: "Recenzi bez jména klienta nejde zveřejnit.",

  google_import_invalid:
    "Data exportu Google Takeout nejsou platná. Nahrajte export znovu tak, jak ho Google Takeout stáhl.",
  google_import_no_location:
    "Nahrání neříká, ke které provozovně patří. Vyberte lokaci a zkuste to znovu.",
  google_import_too_many: "Export obsahuje příliš mnoho recenzí na jeden import.",
  google_import_translation_only:
    "Text recenze obsahuje strojový překlad Googlu místo původního znění autora. Nahrajte export znovu.",

  google_review_invalid: "Údaje Google recenze nejsou platné.",
  google_review_not_manual:
    "Upravit nebo smazat jde jen ručně přidanou Google recenzi. U importované jde jen opravit destinaci nebo ji odstranit natrvalo.",
  google_review_removed: "Tahle Google recenze je odstraněná natrvalo a už ji nejde měnit.",
  google_review_date_invalid: "Zadejte platné datum recenze, které není v budoucnosti.",
  google_review_author_required: "Jméno autora je povinné.",
  google_review_text_required: "Text recenze je povinný.",
  google_review_destination_not_found:
    "Vybraná destinace neexistuje. Obnovte stránku a vyberte jinou.",
  google_review_stars_not_allowed:
    "Hvězdy se nezadávají: ukládají se jen pětihvězdičkové Google recenze.",

  trip_link_trip_unavailable:
    "Navázat jde jen publikovaný zájezd. Zájezd neexistuje nebo není publikovaný.",
  trip_link_inspiration_not_found: "Inspirace už neexistuje. Obnovte stránku.",
  trip_link_overlap: "Tutéž položku nejde zároveň přidat a odebrat.",
};
